<template>
  <div class="software">
    <div class="top">
      <img :src="$apiBaseUrl+top" style="width: 100%;height: 450px">
    </div>
    <div class="con_data">
      <h1 class="center blue Bt">核心业务</h1>
      <div class="center mar-30">公司的核心业务</div>
      <div class="core">
        <div class="lump">
          <img src="../../assets/icon01.png" width="60" height="57">
          <h4 class="mar0">物联网</h4>
          <h4 class="mar0">应用建设</h4>
          <p>八友台智能自有物联网研发团队，在工业4.0、环境监测、智能应用、无线通讯等拥有自有研发成果,其广泛应用于智慧工厂、智慧楼宇、智慧农业、智慧旅游、智慧管廊等智慧城市建设领域。</p>
        </div>
        <div class="lump">
          <img src="../../assets/icon02.png" width="60" height="57">
          <h4 class="mar0">政务</h4>
          <h4 class="mar0">信息化建设</h4>
          <p>八友台智能为政企单位提供从专线服务、综合布线、无线覆盖、视频监控到云服务、企业门户搭建、办公OA、ERP建设。全面解决企业在运营中面临的各种需求,并提供完善的售后服务。自公司成立以来,服务大中小企业数百家,获得企业客户高度认可及评价。</p>
        </div>
        <div class="lump">
          <img src="../../assets/icon03.png" width="60" height="57">
          <h4 class="mar0">企业 </h4>
          <h4 class="mar0">智能制造</h4>
          <p>八友台智能的智能制造系统搭建在企业原有自动化控制系统之上,结合各类传感器、控制器、AI识别等技术,对生产制造过程进行透明化监控，推动人机协作,并对生产制造过程进行智能分析、推理、诊断和决策,从而实现企业生产智能运行、降本增效。</p>
        </div>
      </div>

      <div class="flow">
        <h1 class="center blue Bt">合作流程</h1>
        <div class="center mar-30">
          <p class="center">如果您在购买系统产品后有任何不满意，我们支持5天内无理由退订。</p>
          <p class="center">您可以拨打热线电话19567908984进行操作</p>
        </div>
        <div class="des">
          <div class="lumps">
            <img src="../../assets/icon04.png" width="60" height="57">
            <h4 class="mar0">初步了解</h4>
            <div class="center">PROCESS</div>
          </div>
          <div class="lumps">
            <img src="../../assets/icon05.png" width="60" height="57">
            <h4 class="mar0">现场洽谈</h4>
            <div class="center">NEGOTIATION</div>
          </div>
          <div class="lumps">
            <img src="../../assets/icon06.png" width="60" height="57">
            <h4 class="mar0 center">确认合作</h4>
            <div class="center">COOPERATION</div>
          </div>
          <div class="lumps">
            <img src="../../assets/icon07.png" width="60" height="57">
            <h4 class="mar0">系统培训</h4>
            <div class="center">TRAIN</div>
          </div>
          <div class="lumps">
            <img src="../../assets/icon08.png" width="60" height="57">
            <h4 class="mar0">售后服务</h4>
            <div class="center">AFTER SALE</div>
          </div>
        </div>
      </div>

      <div class="serve">
        <h1 class="center blue Bt">服务政策</h1>
        <div class="center mar-30">向客户提供一流的产品，完成的服务</div>
        <div class="chunk">
          <div class="bor">
            <img src="../../assets/icon09.png" height="57" width="60">
            <div>
              为客户提供产品技术性能培 训、咨询
            </div>
          </div>
          <div class="bor">
            <img src="../../assets/icon10.png" height="57" width="60">
            <div>
              为客户提供产品技术性能培 训、咨询
            </div>
          </div>
          <div class="bor">
            <img src="../../assets/icon11.png" height="57" width="60">
            <div>
              为客户提供产品技术性能培 训、咨询
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "software",
  data(){
    return{
      top:''
    }
  },
  mounted() {
    this.getTop()
  },
  methods:{
    getTop(){
      let data={params:{ImgCate:8}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.top = res.data[0].ImgPath;
      })
    },
  }
}
</script>

<style scoped>
.core,.chunk,.des{
  display: flex;
  justify-content: space-between;
  margin-bottom: 50px;
}
.lump{
  width: 360px;
  text-align: center;
}
.lump p{
  line-height: 25px;
  font-size: 12px;
  color: #555;
}
.chunk .bor{
  display: flex;
  width: 360px;height: 170px;
  padding: 0 50px;
  box-sizing: border-box;
  border: solid 1px #ddd;
  justify-content: space-around;
  vertical-align: middle;
  align-items: center;
}
.lumps{
  text-align: center;
}
.des{
  margin-top: 50px;
}
.chunk .bor img{
  margin-right: 20px;
}
.chunk .bor div{
  line-height: 23px;
  color: #555;
}
</style>